/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Google, MoneyOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTextoBoton from "../../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {getID} from "../../../Servicios/BD/useEscucharUsuarioToCorreo";
import {obtenerDoc} from "../../../Servicios/BD/obtenerDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../../Recursos/logo_redondo.svg";

const Formulario_Contrato_Crear = ({...props}) => {
    const {Avisos, nuevoAviso, terminar, iniciarCarga, Cargador} = useCargador({logoRedondo: logo})

    const buscar = async () => {

        let pal = props.props.getValues("correo");

        if (!pal) {
            return
        }

        iniciarCarga('Buscando')

        let pala = pal.replaceAll(' ', '')
        let id = getID(pala)
        let result = await obtenerDoc('cuentas', id)
        if (result.res) {
            let usuario = result.data
            props.props.setValue('idUsuario', usuario.id)
            props.props.setValue('nombre', usuario.nombre)
            props.props.setValue('codigoUsuario', usuario.codigo)
            props.props.setValue('codigo', usuario.codigo)
            props.props.setValue('minHash', usuario.minHash)

            terminar({aviso: 'Usuario encontrado'})
        } else {
            terminar({aviso: 'No hay cuenta registrada con este correo.', variante: 'error'})
        }

    }


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Avisos/>

                <Cargador/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoBoton nombre={'Correo de usuario'} {...props} dato={'correo'} Icono={Google}
                                       click={buscar}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={MoneyOutlined} nombre={'Codigo'} dato={'minHash'} {...props} editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor del contrato'} dato={'valor'} {...props}/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Contrato_Crear